import { UploadData, useUploadStore } from '../uploadStore';
import { getUploadedSize } from '../../components/main_container/missions/helpers/uploadProgress';
import { UploadType } from '../../consts/uploadType';

export const cacheUploadedSize = (upload: UploadData, save = false) => {
  if (!upload.upload) {
    throw new Error("The upload hasn't been registered");
  }

  upload.meta.uploadedSize = getUploadedSize(upload);

  if (save) {
    useUploadStore
      .getState()
      .setUpload(
        upload.meta.type === UploadType.Pano,
        upload.upload.customer,
        upload.upload.site,
        upload.upload.flightScheduleId,
        upload,
      );
  }
};
